import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaPendenciaProtocolo.vue?vue&type=template&id=16faa605&scoped=true"
import script from "./ModalSolicitacaoCirurgiaPendenciaProtocolo.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaPendenciaProtocolo.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaPendenciaProtocolo.vue?vue&type=style&index=0&id=16faa605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16faa605",
  null
  
)

export default component.exports